import { defineMessages } from "react-intl"

export default defineMessages({
  all: {
    id: "word.chart.all",
    defaultMessage: "CREATION"
  },
  day: {
    id: "word.chart.day",
    defaultMessage: "{count} day(s)"
  },
  hour: {
    id: "word.chart.hour",
    defaultMessage: "{count} hour(s)"
  },
  millisecond: {
    id: "word.chart.millisecond",
    defaultMessage: "{count} ms"
  },
  minute: {
    id: "word.chart.minute",
    defaultMessage: "{count} min."
  },
  month: {
    id: "word.chart.months",
    defaultMessage: "{count} month(s)"
  },
  second: {
    id: "word.chart.second",
    defaultMessage: "{count} sec."
  },
  week: {
    id: "word.chart.week",
    defaultMessage: "{count} week(s)"
  },
  year: {
    id: "word.chart.year",
    defaultMessage: "{count} year(s)"
  },
  oneYear: {
    id: "word.chart.year.one",
    defaultMessage: "{count} year"
  },
  ytd: {
    id: "word.chart.ytd",
    defaultMessage: "YTD"
  }
  // END WARNING
})
